import ValidationType from '../ValidationType';

class MaxTextLength extends ValidationType {
  validateResponseWithValidation(fieldResponse, validation) {
    let errors = [];
    if (!fieldResponse.isEmpty) {
      if (fieldResponse.currentValue.toString().length > parseInt(validation.value)) {
        errors.push(this.createValidationError({
          fieldResponse: fieldResponse,
          key: 'ERROR_MAX_TEXT_LENGTH',
          values: { value: validation.value },
          message: `Maximum text length is ${validation.value} characters`,
        }));
      }
    }
    return errors;
  }
}

export default MaxTextLength;
